import React from "react";
import styles from "./UnauthenticatedHeader.module.css";
import jsonFromDocument from "cerulean/src/JsonFromDocument";
import { Button } from "@narmi/design_system";

export function UnauthenticatedHeader({ rightContent }: { rightContent?: React.ReactNode }) {
  const institutionLogoUrl = jsonFromDocument("institution_logo_url", "");

  return (
    <div className={styles.container}>
      <div className={styles.menu}>
        <a
          href="/"
          className={styles.logo}
          style={{ backgroundImage: `url(${institutionLogoUrl})` }}
          aria-label="Home"
        />
        {rightContent && (
          <div className={styles.rightMenu}>
            <div className={styles.menuItem}>{rightContent}</div>
          </div>
        )}
      </div>
    </div>
  );
}

export function NeedHelpButton() {
  return (
    <Button
      label="Need help?"
      kind="negative"
      href="https://help.narmi.com/"
      target="_blank"
      rel="noopener noreferrer"
      as="a"
    />
  );
}
